var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "product-list-item card",
      attrs: { "data-testing": _vm.item.variation.id },
    },
    [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("div", { staticClass: "product-image-wrapper tile-view-only" }, [
            _c(
              "a",
              {
                attrs: {
                  href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId),
                  title: _vm.item.texts.name1,
                },
              },
              [
                _c("lazy-img", {
                  attrs: {
                    "picture-class": "product-image",
                    "image-url":
                      _vm.item.images.variation.length > 0
                        ? _vm.item.images.variation[0].urlMiddle
                        : _vm.item.images.all[0].urlMiddle,
                    alt: _vm.item.texts.name1,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("item-store-special", {
            attrs: {
              "store-special": _vm.storeSpecial,
              "recommended-retail-price": _vm.item.prices.rrp,
              "variation-retail-price": _vm.item.prices.default,
              "special-offer-price": _vm.item.prices.specialOffer,
              "decimal-count": _vm.decimalCount,
              "bundle-type": _vm.item.variation.bundleType,
              "item-type": _vm.item.item.itemType,
            },
          }),
          _vm._v(" "),
          _c("category-add-wishlist", {
            attrs: { "item-id": _vm.item.variation.id },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "d-none d-md-block attributes__wrapper" }, [
            _c(
              "ul",
              { staticClass: "attributes__list" },
              _vm._l(_vm.sortedAttributes, function (categoryItemAttributes) {
                return _c("li", { staticClass: "attributes__item" }, [
                  categoryItemAttributes.value.image != ""
                    ? _c("img", {
                        staticClass: "attributes__image",
                        attrs: {
                          src:
                            "/images/produkte/grp/" +
                            categoryItemAttributes.value.image,
                          alt: categoryItemAttributes.value.names.name,
                        },
                      })
                    : _c("span", { staticClass: "attributes__name" }, [
                        categoryItemAttributes.attribute.id === 6 ||
                        categoryItemAttributes.attribute.id === 1
                          ? _c("span", {
                              staticClass:
                                "attributes__icon attributes__icon--6",
                            })
                          : categoryItemAttributes.attribute.id === 7 ||
                            categoryItemAttributes.attribute.id === 4 ||
                            categoryItemAttributes.attribute.id === 12
                          ? _c("span", {
                              staticClass:
                                "attributes__icon attributes__icon--7",
                            })
                          : categoryItemAttributes.attribute.id === 8 ||
                            categoryItemAttributes.attribute.id === 5
                          ? _c("span", {
                              staticClass:
                                "attributes__icon attributes__icon--8",
                            })
                          : categoryItemAttributes.attribute.id === 13 ||
                            categoryItemAttributes.attribute.id === 2
                          ? _c("span", {
                              staticClass:
                                "attributes__icon attributes__icon--13",
                            })
                          : categoryItemAttributes.attribute.id === 14 ||
                            categoryItemAttributes.attribute.id === 11
                          ? _c("span", {
                              staticClass:
                                "attributes__icon attributes__icon--14",
                            })
                          : categoryItemAttributes.attribute.id === 15
                          ? _c("span", {
                              staticClass:
                                "attributes__icon attributes__icon--15",
                            })
                          : categoryItemAttributes.attribute.id === 16
                          ? _c("span", {
                              staticClass:
                                "attributes__icon attributes__icon--16",
                            })
                          : _c("span", {
                              staticClass:
                                "attributes__icon attributes__icon--else",
                            }),
                        _vm._v(" "),
                        _c("span", { staticClass: "attributes__name-text" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(categoryItemAttributes.value.names.name) +
                              "\n                        "
                          ),
                        ]),
                      ]),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _vm.sortedAttributes.length > 0
              ? _c("div", { staticClass: "attributes__more" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$translate("OD3dprimaV2::Template.moreOptions")
                      ) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-details__wrapper" }, [
            _c(
              "div",
              { staticClass: "product-info" },
              [
                _c("div", { staticClass: "item-details__informations" }, [
                  _c(
                    "div",
                    { staticClass: "product-image-wrapper list-view-only" },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm._f("itemURL")(
                              _vm.item,
                              _vm.urlWithVariationId
                            ),
                            title: _vm.item.texts.name1,
                          },
                        },
                        [
                          _c("lazy-img", {
                            attrs: {
                              "picture-class": "product-image",
                              "image-url":
                                _vm.item.images.variation.length > 0
                                  ? _vm.item.images.variation[0].urlMiddle
                                  : _vm.item.images.all[0].urlMiddle,
                              alt: _vm.item.texts.name1,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "item-details__info" },
                    [
                      _vm._t("ratings"),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "product-name",
                          attrs: {
                            href: _vm._f("itemURL")(
                              _vm.item,
                              _vm.urlWithVariationId
                            ),
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm._f("itemName")(_vm.item)) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "item-details__item-id small tile-view-only",
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$translate(
                                  "OD3dprimaV2::Template.variationId"
                                )
                              ) +
                              ": "
                          ),
                          _c("span", [_vm._v(_vm._s(_vm.item.variation.id))]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "item-details__item-id small tile-view-only",
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$translate("OD3dprimaV2::Template.ItemNo")
                              ) +
                              ": "
                          ),
                          _c("span", [_vm._v(_vm._s(_vm.item.item.id))]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "item-details__attributes list-view-only",
                        },
                        [
                          _c("span", { staticClass: "product-id" }, [
                            _c("strong", [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "OD3dprimaV2::Template.variationId"
                                    )
                                  ) +
                                  ": "
                              ),
                              _c("span", [
                                _vm._v(_vm._s(_vm.item.variation.id)),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "product-id" }, [
                            _c("strong", [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "OD3dprimaV2::Template.ItemNo"
                                    )
                                  ) +
                                  ": "
                              ),
                              _c("span", [_vm._v(_vm._s(_vm.item.item.id))]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.ean
                            ? _c(
                                "span",
                                { staticClass: "product-ean list-view-only" },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$translate(
                                            "OD3dprimaV2::Template.EAN"
                                          )
                                        ) +
                                        ": "
                                    ),
                                    _c("span", [_vm._v(_vm._s(_vm.ean.code))]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.sortedAttributes.length
                    ? _c(
                        "div",
                        { staticClass: "attributes attributes-list-view-only" },
                        [
                          _c(
                            "ul",
                            { staticClass: "attributes__list" },
                            _vm._l(
                              _vm.sortedAttributes,
                              function (categoryItemAttributes) {
                                return _c(
                                  "li",
                                  {
                                    class:
                                      "attributes__item attributes__item--" +
                                      categoryItemAttributes.attribute.id,
                                  },
                                  [
                                    categoryItemAttributes.value.image != ""
                                      ? _c("img", {
                                          staticClass: "attributes__image",
                                          attrs: {
                                            src:
                                              "/images/produkte/grp/" +
                                              categoryItemAttributes.value
                                                .image,
                                            alt: categoryItemAttributes.value
                                              .names.name,
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "attributes__name" },
                                      [
                                        categoryItemAttributes.attribute.id ===
                                          6 ||
                                        categoryItemAttributes.attribute.id ===
                                          1
                                          ? _c("span", {
                                              staticClass:
                                                "attributes__icon attributes__icon--6",
                                            })
                                          : categoryItemAttributes.attribute
                                              .id === 7 ||
                                            categoryItemAttributes.attribute
                                              .id === 4 ||
                                            categoryItemAttributes.attribute
                                              .id === 12
                                          ? _c("span", {
                                              staticClass:
                                                "attributes__icon attributes__icon--7",
                                            })
                                          : categoryItemAttributes.attribute
                                              .id === 8 ||
                                            categoryItemAttributes.attribute
                                              .id === 5
                                          ? _c("span", {
                                              staticClass:
                                                "attributes__icon attributes__icon--8",
                                            })
                                          : categoryItemAttributes.attribute
                                              .id === 13 ||
                                            categoryItemAttributes.attribute
                                              .id === 2
                                          ? _c("span", {
                                              staticClass:
                                                "attributes__icon attributes__icon--13",
                                            })
                                          : categoryItemAttributes.attribute
                                              .id === 14 ||
                                            categoryItemAttributes.attribute
                                              .id === 11
                                          ? _c("span", {
                                              staticClass:
                                                "attributes__icon attributes__icon--14",
                                            })
                                          : categoryItemAttributes.attribute
                                              .id === 15
                                          ? _c("span", {
                                              staticClass:
                                                "attributes__icon attributes__icon--15",
                                            })
                                          : categoryItemAttributes.attribute
                                              .id === 16
                                          ? _c("span", {
                                              staticClass:
                                                "attributes__icon attributes__icon--16",
                                            })
                                          : _c("span", {
                                              staticClass:
                                                "attributes__icon attributes__icon--else",
                                            }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "attributes__name-text",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  categoryItemAttributes.value
                                                    .names.name
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "attributes__more" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$translate(
                                    "OD3dprimaV2::Template.moreOptions"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm._t("before-prices"),
                _vm._v(" "),
                _c("div", { staticClass: "item-details__price-wrapper" }, [
                  _c("div", [
                    _vm.item.prices.default.unitPrice.value > 0
                      ? _c(
                          "div",
                          {
                            staticClass: "product-price",
                            class: {
                              "product-price--sale":
                                _vm.item.prices.rrp &&
                                _vm.item.prices.rrp.price.value > 0 &&
                                _vm.item.prices.rrp.price.value >
                                  _vm.item.prices.default.unitPrice.value,
                            },
                            style: !_vm.mounted
                              ? "opacity: 0; padding-top: 2px"
                              : "opacity: 1",
                          },
                          [
                            _vm.item.prices.rrp &&
                            _vm.item.prices.rrp.price.value > 0 &&
                            _vm.item.prices.rrp.price.value >
                              _vm.item.prices.default.unitPrice.value
                              ? [
                                  _vm.item.prices.specialOffer
                                    ? _c(
                                        "span",
                                        { staticClass: "product-price--uvp" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm._f("currency")(
                                                  _vm.getPrice(
                                                    "prices.default.data.unitPrice" +
                                                      _vm.appendNet
                                                  )
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "product-price--uvp" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm._f("currency")(
                                                  _vm.getPrice(
                                                    "prices.rrp.data.unitPrice" +
                                                      _vm.appendNet
                                                  )
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.item.itemType === "set"
                              ? _c("span", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemSetPrice",
                                          {
                                            price: _vm.getPrice("itemSetPrice"),
                                          }
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ])
                              : !!_vm.item.item &&
                                _vm.item.item.salableVariationCount > 1 &&
                                _vm.$ceres.isCheapestSorting
                              ? [
                                  _vm.mounted
                                    ? _c("span", {
                                        domProps: {
                                          innerHTML: _vm.$translate(
                                            "OD3dprimaV2::Template.categoryItemFromPrice",
                                            {
                                              price: _vm.getPrice(
                                                "itemPrice",
                                                true
                                              ),
                                            }
                                          ),
                                        },
                                      })
                                    : _c("span", [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$translate(
                                                "OD3dprimaV2::Template.categoryItemFromPrice",
                                                {
                                                  price:
                                                    _vm.getPrice("itemPrice"),
                                                }
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ]),
                                ]
                              : [
                                  _vm.mounted
                                    ? _c("span", {
                                        domProps: {
                                          innerHTML: _vm._f("currency")(
                                            _vm._f("specialOffer")(
                                              _vm.getPrice(
                                                "prices.default.data.unitPrice" +
                                                  _vm.appendNet
                                              ),
                                              _vm.item.prices,
                                              "data",
                                              "unitPrice" + _vm.appendNet
                                            ),
                                            true
                                          ),
                                        },
                                      })
                                    : _c("span", [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm._f("currency")(
                                                _vm._f("specialOffer")(
                                                  _vm.getPrice(
                                                    "prices.default.data.unitPrice" +
                                                      _vm.appendNet
                                                  ),
                                                  _vm.item.prices,
                                                  "data",
                                                  "unitPrice" + _vm.appendNet
                                                )
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ]),
                                ],
                            _vm._v(" "),
                            _vm.item.variation.mayShowUnitPrice === true
                              ? _c(
                                  "span",
                                  { staticClass: "product-price--base small" },
                                  [
                                    _vm._v(
                                      "\n                                (" +
                                        _vm._s(
                                          _vm.$translate(
                                            "OD3dprimaV2::Template.basePrice"
                                          )
                                        ) +
                                        ":\n                                " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.getPrice(
                                              "prices.default.data.basePrice" +
                                                _vm.appendNet
                                            ) / _vm.item.unit.content
                                          )
                                        ) +
                                        "/" +
                                        _vm._s(_vm.unitName) +
                                        ")\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.stock.net >= 1
                      ? _c(
                          "div",
                          {
                            staticClass: "item-details__stock",
                            class: {
                              "item-details__stock--no": _vm.item.stock.net < 1,
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "24",
                                  height: "15",
                                },
                              },
                              [
                                _c("use", {
                                  attrs: {
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                    "xlink:href": "#svg-stock-icon",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "stock-list-view" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$translate(
                                      "OD3dprimaV2::Template.stock"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "stock-tile-view" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$translate(
                                      "OD3dprimaV2::Template.stockAvailable"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(
                              "\n                             " +
                                _vm._s(_vm.stock) +
                                "\n                        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.stock.net < 1
                      ? _c(
                          "div",
                          { staticClass: "category-listing-estimated small" },
                          [
                            _vm.showEstimatedDate
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "product-detail__availability",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          title: _vm.$translate(
                                            "Ceres::Template.singleItemShippingCosts"
                                          ),
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "product-detail-availability__truck",
                                            attrs: {
                                              id: "Ebene_1",
                                              "data-name": "Ebene 1",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              viewBox: "0 0 400 400",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              staticClass: "cls-1",
                                              attrs: {
                                                d: "M386.51 192.94l.11-.32a4.41 4.41 0 0 0 .2-1.3 4.23 4.23 0 0 0-1.26-3l-.25-.24-.11-.32a27.07 27.07 0 0 0-13.43-15l-.4-.18-19.72-7.4-11.8-44.82a27.06 27.06 0 0 0-26.09-19.42H271.9v-13a10 10 0 0 0-10-10H32.07a10 10 0 0 0-10 10v160.84a10 10 0 0 0 10 10H53l-.58 1.93a39.31 39.31 0 0 0-1.22 5.53l-.2 1.28H26.33a4.25 4.25 0 1 0 0 8.49H51l.18 1.29a38.72 38.72 0 0 0 76.64 0l.18-1.3h14.71v1.5a15.75 15.75 0 0 0 15.73 15.74H193a15.76 15.76 0 0 0 15.74-15.74V276h72.17l.18 1.29a38.72 38.72 0 0 0 76.64 0l.19-1.29h24.7a4.25 4.25 0 0 0 0-8.49h-24.7l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h20.93a10 10 0 0 0 10-10v-51.69a26.72 26.72 0 0 0-.26-3.79zM271.9 109.38h41.86a18.63 18.63 0 0 1 17.92 13.26l10.91 41.45H271.9zm0 63.2h75.43l20.91 7.86a18.81 18.81 0 0 1 5.33 4.13l2.24 2.51H271.9zM89.53 302a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 89.53 302zm54.12-41.23a15.66 15.66 0 0 0-.9 5.25v1.5H128l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h18.3zm56.56 16.74a7.26 7.26 0 0 1-7.25 7.25h-34.48a7.25 7.25 0 0 1-7.24-7.25V266a7.25 7.25 0 0 1 7.24-7.25H193a7.26 7.26 0 0 1 7.25 7.25zM124 250.28a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13H30.57v-31.73H210.2a4.25 4.25 0 1 0 0-8.49H30.57V86.39h232.84v163.89zm158.27 10.42a39 39 0 0 0-1.22 5.53l-.18 1.29H208.7V266a15.92 15.92 0 0 0-.9-5.25l-.71-2h75.75zm37.1 41.3a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 319.37 302zm59-91.94h-7.24a10 10 0 0 0-10 10v5.75a10 10 0 0 0 10 10h7.24v14.49h-24.52a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13h-13v-54.73h106.39zm0 8.49v8.75h-8.75v-8.75z",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              staticClass: "cls-1",
                                              attrs: {
                                                d: "M320.8 258.43a14.67 14.67 0 1 0 14.67 14.67 14.69 14.69 0 0 0-14.67-14.67zm0 22.85a8.18 8.18 0 1 1 8.2-8.18 8.19 8.19 0 0 1-8.2 8.18zM89.83 257.29A14.67 14.67 0 1 0 104.49 272a14.69 14.69 0 0 0-14.66-14.71zm0 22.85A8.18 8.18 0 1 1 98 272a8.19 8.19 0 0 1-8.17 8.14z",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.estimatedAvailable) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm.orderOnRequest
                              ? _c(
                                  "div",
                                  { staticClass: "category-listing-request" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$translate(
                                            "OD3dprimaV2::Template.orderOnRequest"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "product-detail__availability",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          title: _vm.$translate(
                                            "Ceres::Template.singleItemShippingCosts"
                                          ),
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "product-detail-availability__truck",
                                            attrs: {
                                              id: "Ebene_1",
                                              "data-name": "Ebene 1",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              viewBox: "0 0 400 400",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              staticClass: "cls-1",
                                              attrs: {
                                                d: "M386.51 192.94l.11-.32a4.41 4.41 0 0 0 .2-1.3 4.23 4.23 0 0 0-1.26-3l-.25-.24-.11-.32a27.07 27.07 0 0 0-13.43-15l-.4-.18-19.72-7.4-11.8-44.82a27.06 27.06 0 0 0-26.09-19.42H271.9v-13a10 10 0 0 0-10-10H32.07a10 10 0 0 0-10 10v160.84a10 10 0 0 0 10 10H53l-.58 1.93a39.31 39.31 0 0 0-1.22 5.53l-.2 1.28H26.33a4.25 4.25 0 1 0 0 8.49H51l.18 1.29a38.72 38.72 0 0 0 76.64 0l.18-1.3h14.71v1.5a15.75 15.75 0 0 0 15.73 15.74H193a15.76 15.76 0 0 0 15.74-15.74V276h72.17l.18 1.29a38.72 38.72 0 0 0 76.64 0l.19-1.29h24.7a4.25 4.25 0 0 0 0-8.49h-24.7l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h20.93a10 10 0 0 0 10-10v-51.69a26.72 26.72 0 0 0-.26-3.79zM271.9 109.38h41.86a18.63 18.63 0 0 1 17.92 13.26l10.91 41.45H271.9zm0 63.2h75.43l20.91 7.86a18.81 18.81 0 0 1 5.33 4.13l2.24 2.51H271.9zM89.53 302a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 89.53 302zm54.12-41.23a15.66 15.66 0 0 0-.9 5.25v1.5H128l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h18.3zm56.56 16.74a7.26 7.26 0 0 1-7.25 7.25h-34.48a7.25 7.25 0 0 1-7.24-7.25V266a7.25 7.25 0 0 1 7.24-7.25H193a7.26 7.26 0 0 1 7.25 7.25zM124 250.28a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13H30.57v-31.73H210.2a4.25 4.25 0 1 0 0-8.49H30.57V86.39h232.84v163.89zm158.27 10.42a39 39 0 0 0-1.22 5.53l-.18 1.29H208.7V266a15.92 15.92 0 0 0-.9-5.25l-.71-2h75.75zm37.1 41.3a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 319.37 302zm59-91.94h-7.24a10 10 0 0 0-10 10v5.75a10 10 0 0 0 10 10h7.24v14.49h-24.52a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13h-13v-54.73h106.39zm0 8.49v8.75h-8.75v-8.75z",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              staticClass: "cls-1",
                                              attrs: {
                                                d: "M320.8 258.43a14.67 14.67 0 1 0 14.67 14.67 14.69 14.69 0 0 0-14.67-14.67zm0 22.85a8.18 8.18 0 1 1 8.2-8.18 8.19 8.19 0 0 1-8.2 8.18zM89.83 257.29A14.67 14.67 0 1 0 104.49 272a14.69 14.69 0 0 0-14.66-14.71zm0 22.85A8.18 8.18 0 1 1 98 272a8.19 8.19 0 0 1-8.17 8.14z",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.estimatedAvailable) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "list-view-only-mobile" },
                    [
                      _vm.item.prices.default.unitPrice.value > 0
                        ? _c("add-to-basket", {
                            attrs: {
                              "data-testing": "item-add-to-basket",
                              "variation-id": _vm.item.variation.id,
                              "is-salable":
                                !!_vm.item.filter && _vm.item.filter.isSalable,
                              "has-children":
                                !!_vm.item.item &&
                                _vm.item.item.salableVariationCount > 1,
                              "interval-quantity":
                                _vm.item.variation.intervalOrderQuantity || 1,
                              "minimum-quantity":
                                _vm.item.variation.minimumOrderQuantity,
                              "maximum-quantity":
                                !!_vm.item.variation.maximumOrderQuantity &&
                                _vm.item.variation.maximumOrderQuantity > 0
                                  ? _vm.item.variation.maximumOrderQuantity
                                  : null,
                              "order-properties": _vm.item.properties.filter(
                                function (prop) {
                                  return prop.property.isOderProperty
                                }
                              ),
                              "has-order-properties":
                                _vm.item.hasOrderProperties,
                              "has-required-order-property":
                                _vm.item.hasRequiredOrderProperty,
                              "use-large-scale": false,
                              "show-quantity": true,
                              "item-url": _vm._f("itemURL")(
                                _vm.item,
                                _vm.urlWithVariationId
                              ),
                              "has-price": _vm._f("hasItemDefaultPrice")(
                                _vm.item
                              ),
                              "item-type": _vm.item.item.itemType,
                              "has-graduated-price":
                                _vm.itemGraduatedPriceisCheapestSorting ||
                                _vm.itemGraduatedPricesalableVariationCount,
                              "item-free-four": String(_vm.item.item.free4),
                            },
                          })
                        : _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-block btn-primary btn-appearance add-to-basket__btn",
                              attrs: {
                                href: _vm._f("itemURL")(
                                  _vm.item,
                                  _vm.urlWithVariationId
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$translate(
                                      "OD3dprimaV2::Template.contactForAQuote"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm._t("after-prices"),
              ],
              2
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }